import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import axios from 'axios';
import qs from "qs";
// import {Link} from 'react-router-dom';
// import NavBar from '../../components/nav-bar/nav-bar';
// import styles from "../../lib/global.css";
import Page from "../../components/page/page";
import Banner from "./banner/banner";
import MyFooter from '../../components/footer/footer.jsx';
import { getCourse, getCourses } from "../../api/course";
import { getCourseRecords } from "../../api/course-record";
import { getMyProjects, getRecommendedProjects } from "../../api/project";
import PropTypes from "prop-types";
import { setCourseRecords, setCourses, setMyProjects, setRecommendedProjects, setUser } from "../../reducers/teach";
import { connect } from "react-redux";
// import cn from "classnames";
import CourseRecordList from "../../components/course-record-list/course-record-list";
// import CourseList from "../../components/course-list/course-list";
import Card from "../../components/card/card";
import PageContentMargin from "../../components/page-content-margin/page-content-margin";
import ProjectList from "../../components/project-list/project-list";
// import RecommendedProjectDataTrans from "../../components/project-list/recommended-project-data-trans";
import LessonList from "../../components/lesson-list/lesson-list";
import LoginEntry from "../../../components/menu-bar/login-entry";

SwiperCore.use([Autoplay, Pagination])

let num = 1;

class HomePage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.query = qs.parse(location.search, { ignoreQueryPrefix: true });
        this.videoRef = React.createRef();
        this.state = { basicCourse: null, zjCourse: null, img: null };
    }

    componentDidMount() {
        const token = this.query.token
        if (token) {
            localStorage.setItem('api-token', token)
        }
        this.getData()
        document.title = "小奥AI编程--致奥数据科技"
        const reloadPage = localStorage.getItem('refresh')
        if (reloadPage === 'true') {
            localStorage.removeItem('refresh')
            location.reload()
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.user.id !== nextProps.user.id) {
            this.getData()
            this.getTicket()
        }
    }

    getData() {
        getCourses({ page_size: 100 }, { quiet: true }).then(res => {
            const promises = res.data.map((item, index) => {
                return getCourse({ id: item.id }, { quiet: true }).then(res2 => {
                    res.data[index] = res2;
                })
            });
            Promise.all(promises).then(() => {
                this.props.setCourses(res);
            });

        });
        getCourseRecords({ studying: 1, page_size: 100 }, { quiet: true }).then(res => this.props.setCourseRecords(res));
        getRecommendedProjects({ page_size: 100 }, { quiet: true }).then(res => this.props.setRecommendedProjects(res));
        getMyProjects({ page_size: 100 }, { quiet: true }).then(res => this.props.setMyProjects(res));
    }

    //获取渠道二维码
    getTicket() {
        const { user } = this.props
        axios.defaults.headers['api-token'] = localStorage.getItem('api-token')
        axios.get(`${window.config.apiBaseURL}/weixin/get-qrcode?type=${user.ct > 0 ? 'QR_LIMIT_SCENE' : 'QR_SCENE'}`).then(res => {
            const { data } = res
            if (data.msg.ticket) {
                this.setState({
                    img: `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${data.msg.ticket}`
                })
            }
            num = 2;
        }).catch(() => {
            this.setState({ img: null })
        })
    }

    render() {
        let myProjectListData;
        const { basicCourse, zjCourse, img } = this.state;

        if (this.props.myProjects.data.length > 0) {
            myProjectListData = [{ id: 0, img: require('../projects/start_create.png') }].concat(this.props.myProjects.data);
        } else {
            myProjectListData = [{ id: 0, img: require('../projects/start_create.png') }];
        }
        const { courses } = this.props;

        return (
            <Page>
                <div style={{ position: 'relative' }}>
                    <div style={{ position: 'absolute', top: '30px', right: '85px', zIndex: 100 }}>
                        <LoginEntry></LoginEntry>
                    </div>
                    <Swiper
                        spaceBetween={0}
                        // loop={true}
                        autoplay
                    // pagination
                    // autoHeight={true}
                    >
                        <SwiperSlide><Banner videoRef={this.videoRef} images={[img]} /></SwiperSlide>
                    </Swiper>
                    {/* <Banner videoRef={this.videoRef} images={[img]} /> */}
                </div>
                <PageContentMargin>
                    {(this.props.courseRecords && this.props.courseRecords.data.length > 0) ? (
                        <Card title={window.L('teach.course.studyingCourses')} subTitle={window.L('teach.course.studyingCoursesSubtitle')} moreURL="./courses/studying">
                            <CourseRecordList
                                items={this.props.courseRecords.data.slice(0, 4)}
                            />
                        </Card>
                    ) : null}
                    {/*推荐课程
                    (this.props.courses && this.props.courses.data.length > 0) ? (
                        <Card title={window.L('teach.course.recommendedCourses')} subTitle={window.L('teach.course.recommendedCoursesSubtitle')} moreURL="./courses/recommended">
                            <CourseList
                                items={this.props.courses.data.slice(0, 4)}
                            />
                        </Card>
                    ) : null*/}
                    {(courses && courses.data.length > 0 && courses.data[0].lessons && courses.data[0].lessons.length > 0) ? (
                        courses.data.map(item => (
                            // console.log(item)
                            <Card title={item.name} subTitle={item.desc} moreURL={`./course?id=${item.id}` + (item.record ? `&clazz_id=${item.record.clazz_id}` : '')} key={item.id}>
                                <LessonList items={item.lessons.slice(0, 8)} courseId={item.id} clazzId={item.record ? item.record.clazz_id : undefined}
                                    disableUrl={item.record ? '' : `./course?id=${item.id}`} vip={item.clazz_course && item.clazz_course.exp_lesson_count ? item.clazz_course.exp_lesson_count : null} user={this.props.user} props={this.props} />
                            </Card>
                        ))
                    ) : null}
                    {(basicCourse && basicCourse.lessons) ? (
                        <Card title={basicCourse.name} subTitle={basicCourse.desc} moreURL={`./course?id=${basicCourse.id}` + (basicCourse.record ? `&clazz_id=${basicCourse.record.clazz_id}` : '')}>
                            <LessonList items={basicCourse.lessons.slice(0, 8)} courseId={basicCourse.id} clazzId={basicCourse.record ? basicCourse.record.clazz_id : undefined}
                                disableUrl={basicCourse.record ? '' : `./course?id=${basicCourse.id}`} />
                        </Card>
                    ) : null}
                    {(zjCourse && zjCourse.lessons) ? (
                        <Card title={zjCourse.name} subTitle={zjCourse.desc} moreURL={`./course?id=${zjCourse.id}` + (zjCourse.record ? `&clazz_id=${zjCourse.record.clazz_id}` : '')}>
                            <LessonList items={zjCourse.lessons.slice(0, 8)} courseId={zjCourse.id} clazzId={zjCourse.record ? zjCourse.record.clazz_id : undefined}
                                disableUrl={zjCourse.record ? '' : `./course?id=${zjCourse.id}`} />
                        </Card>
                    ) : null}
                    <Card title={window.L('teach.project.myProjects')} subTitle={window.L('teach.project.myProjectsSubtitle')} moreURL="./projects/mine">
                        <ProjectList
                            items={myProjectListData.slice(0, 4)}
                        />
                    </Card>
                    {(this.props.recommendedProjects && this.props.recommendedProjects.data.length > 0) ? (
                        <Card title={window.L('teach.project.recommendedProjects')} subTitle={window.L('teach.project.recommendedProjectsSubtitle')} moreURL="./projects/recommended">
                            <ProjectList items={this.props.recommendedProjects.data.slice(0, 8)} />
                        </Card>
                    ) : null}
                </PageContentMargin>
                <MyFooter></MyFooter>
            </Page>
        );
    }
}
HomePage.propTypes = {
    courses: PropTypes.object,
    courseRecords: PropTypes.object,
    setCourses: PropTypes.func,
    setCourseRecords: PropTypes.func,
    recommendedProjects: PropTypes.object,
    setRecommendedProjects: PropTypes.func,
    myProjects: PropTypes.object,
    setMyProjects: PropTypes.func,
    user: PropTypes.object
};

const mapStateToProps = state => ({
    courses: state.teach.courses,
    courseRecords: state.teach.courseRecords,
    recommendedProjects: state.teach.recommendedProjects,
    myProjects: state.teach.myProjects,
    user: state.teach.user
});


const mapDispatchToProps = dispatch => ({
    setUser: user => dispatch(setUser(user)),
    setCourses: courses => dispatch(setCourses(courses)),
    setCourseRecords: courseRecords => dispatch(setCourseRecords(courseRecords)),
    setRecommendedProjects: projects => dispatch(setRecommendedProjects(projects)),
    setMyProjects: projects => dispatch(setMyProjects(projects)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomePage);
